module.exports = __webpack_public_path__ + "img/logo.317edebf.svg";